import React from 'react'
import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'
import { OwOrder } from '@yy/one-icon'
import { withRedirect } from '@/components/Authorization'
import { withAddressSplitAlgorithmTrack } from '@/bizComponents/AddressAutoSplit/AddressSplitAlgorithmTrack'

const routes: RouteConfig[] = [
  {
    name: 'order',
    menuTitle: 'common.router.order',
    path: '/order',
    component: withRedirect(Blank),
    icon: <OwOrder />,
    authCode: 'sales',
    routes: [
      {
        menuTitle: 'order.index.title',
        component: withAsync(() => import(/* webpackChunkName: "order" */ '@/containers/Order/Index')),
        path: '/list',
        authCode: 'sales:outbounds',
        exact: true,
      },
      {
        component: withAddressSplitAlgorithmTrack(
          withAsync(() => import(/* webpackChunkName: "order" */ '@/containers/Order/Create')),
          (props: any) => {
            const { search } = props?.location || {}
            return (search as string).indexOf('outboundOrderId=') !== -1 ? 'orderEdit' : 'orderCreate'
          }
        ),
        path: '/create',
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '编辑订单',
        hideInMenu: true,
        parentKeys: ['/order/list'],
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "order" */ '@/containers/Order/Detail')),
        path: '/detail',
        exact: true,
        // 用于关联parentKeys，没有menuTitle会被过滤
        menuTitle: '订单详情',
        hideInMenu: true,
        parentKeys: ['/order/list'],
      },
      {
        component: withAsync(() => import(/* webpackChunkName: "order" */ '@/containers/Order/PreMerge')),
        path: '/preMerge',
        exact: true,
        menuTitle: 'order.combineOrder',
        hideInMenu: true,
        parentKeys: ['/order/list'],
      },
    ],
  },
]

export default routes
